import { Box } from '@web/components/atoms/Layout'
import { SectionBody } from '@web/components/atoms/Typography'
import { useDonationFormContext } from '../../DonationFormProvider'
import { DonationFrequency } from '@web/graphql-components'
import { DONATION_FREQUENCY_TO_LABEL } from '../../donationUtils'

const DonationAmountBanner = () => {
  const amount = useDonationFormContext((state) => state.formValues.amount)
  const givingFrequency = useDonationFormContext((state) => state.formValues.givingFrequency)
  const hasUpsellModule = useDonationFormContext((state) => state.settings.styles?.options?.upsellRegularGivingOptions)

  if (!hasUpsellModule) {
    return null
  }

  return (
    <Box
      w="100%"
      py="8px"
      borderRadius="4px"
      bgColor="var(--branding-button-primary-bg-color)"
      color="var(--branding-button-primary-text-color)"
      textAlign="center"
    >
      <SectionBody>
        Donating ${amount ?? 0}{' '}
        {givingFrequency && givingFrequency !== DonationFrequency.OneTime
          ? DONATION_FREQUENCY_TO_LABEL[givingFrequency]
          : ''}
      </SectionBody>
    </Box>
  )
}

export default DonationAmountBanner
